import * as React from 'react'
import classNames from 'classnames'
import {classes} from './empty-state.st.css'
import {EmptyStateProps} from '.'

export const EmptyState: React.FC<EmptyStateProps> = ({t, mobile}) => (
  <div className={classNames(classes.root, {[classes.mobile]: mobile})}>{t('scheduleEmptyStateText')}</div>
)
